module.exports = __webpack_public_path__ + "static/img/PR.66526286.jpg";